import axios, { type AxiosResponse } from "axios";
import { baseUrl } from "./constants";

// Interfaces
export interface CreateAttachmentResponse {
  session_uid: string;
}

// Axios request
export function createAttachment(
  chat_session_uid: string,
  file: File,
): Promise<AxiosResponse<CreateAttachmentResponse>> {
  const formData = new FormData();
  formData.append("file", file);

  return axios.post<CreateAttachmentResponse>(
    `${baseUrl}/api/v1/quotation-request-chat/${chat_session_uid}/attachments`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    },
  );
}
